// extracted by mini-css-extract-plugin
module.exports = {"curatedPage":"styles_curatedPage__2ytYy","description":"styles_description__3Wr8J","richText":"styles_richText__2RCYJ"};